export default {
  FILTER_STUDENT_LIST: 'FilterStudentList',
  SORT_STUDENT_LIST: 'SortStudentList',
  LOAD_STUDENT_LIST_START: 'LoadStudentListStart',
  LOAD_STUDENT_LIST_END: 'LoadStudentListEnd',
  SEARCH_STUDENT_LIST_FILTER_STUDY_PROGRAM_START: 'SearchStudentListFilterStudyProgramStart',
  SEARCH_STUDENT_LIST_FILTER_STUDY_PROGRAM_END: 'SearchStudentListFilterStudyProgramEnd',
  LOAD_STUDENT_LIST_STUDENT_TYPES: 'LoadStudentListStudentTypes'
};